import { ProductMetaData } from '../../../models/Product';
import { addProductsFromCatalogueByIds, AddProductsFromCatalogueByIdsRequest } from './addProductsFromCatalogueByIds';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { bulkUpdateToCart } from './bulkUpdateToCart';
import { SOURCE_CATALOGUE } from '../../store/constants';
import { TFunction } from 'i18next';
import { BulkAddProductsToShoppingCartResponse } from '../../store/api';
import { PriceTier, serializePriceTier } from '../../../models/PriceTier';
import { SubscriptionPeriodType } from '../../../models/Article';
import { useNotification } from '../../app-store/notification/useNotification';

type GetRequestParams = {
    products: ReadonlyArray<ProductMetaData>;
    performChecks: boolean;
    priceTier: PriceTier;
    subscriptionPeriodType: SubscriptionPeriodType;
};

const buildAddProductsCallback = (
    { products, performChecks, priceTier, subscriptionPeriodType }: GetRequestParams,
    t: TFunction
): (() => Promise<BulkAddProductsToShoppingCartResponse>) => {
    const productIds = products.map(product => product.id);
    return () => {
        try {
            const body: AddProductsFromCatalogueByIdsRequest = {
                productIds,
                targetPrice: serializePriceTier(priceTier)!,
                subscriptionPeriodType,
                checkEpress: false
            };

            return addProductsFromCatalogueByIds({
                body,
                params: {
                    performChecks
                }
            });
        } catch (e) {
            throw new Error(t('notifications.buildAddProductsCallback.error'));
        }
    };
};

export const useAddTopChartProductsToCart = () => {
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);
    const { showNotificationWithInfo } = useNotification();

    return {
        isLoading,
        addToCartBulk: (
            products: ReadonlyArray<ProductMetaData>,
            performChecks: boolean,
            priceTier: PriceTier,
            subscriptionPeriodType: SubscriptionPeriodType
        ) => {
            const apiCallback = buildAddProductsCallback(
                {
                    products,
                    performChecks,
                    priceTier,
                    subscriptionPeriodType
                },
                t
            );

            return bulkUpdateToCart({
                setLoading,
                performChecks,
                source: SOURCE_CATALOGUE,
                apiCallback,
                t,
                onSuccess: () => {},
                productSelection: undefined,
                showNotificationWithInfo
            });
        }
    };
};
